<template>
  <div>
    <span>Доход от реф. программы за всё время (монет): {{ moneyReceivedAmount }}</span>
    <br>
    <span>Сумма, доступная к выводу (монет): {{ freeAmount }}</span>
    <br>
    <div v-if="refDeps">
      <span>Сумма депозитов рефералов: {{ refDeps.replenishment_sum }}</span>
      <br>
      <span>Количество депозитов рефералов: {{ refDeps.replenishment_count }}</span>
      <br>
      <span>Сумма выводов рефералов: {{ refDeps.output_sum }}</span>
      <br>
      <span>Количество выводов рефералов: {{ refDeps.output_count }}</span>
      <br>
      <span>Сумма депозитов рефералов, за месяц: {{ refDeps.replenishment_current_month_sum_alt }}</span>
      <br>
      <span>Сумма выводов рефералов, за месяц: {{ refDeps.output_current_month_sum_alt }}</span>
      <br>
      <span>Количество новых игроков, которые сделали депозитов на сумму от 500р., за месяц: {{ refDeps.count_new_users_current_month_deposits_more_500 }}</span>
      <br>
      <span>Сумма первых депозитов, за месяц: {{ refDeps.first_replenishment_by_month_sum }}</span>
      <br>
      <span>Количество повторных депозитов: {{ refDeps.repeated_replenishment_count }}</span>
      <br>
      <span>Сумма повторных депозитов: {{ refDeps.repeated_replenishment_sum }}</span>
      <br>
      <span>Средний депозит (сумма): {{ refDeps.average_deps_sum }}</span>
      <br>
      <span>Количество регистраций новых игроков, за месяц: {{ refDeps.new_users_month_count }}</span>
      <br>
      <span>Количество первых депозитов / Количество регистраций игроков, в %: {{ refDeps.new_players_to_first_deposits_attitude }}</span>
    </div>
    <v-text-field
      v-model="searchName"
      class="search-input"
      append-icon="search"
      label="Ник"
      color="accent"
      single-line
      hide-details
    />
    <v-text-field
      v-model="searchId"
      class="search-input"
      append-icon="search"
      label="Id"
      single-line
      color="accent"
      hide-details
      type="number"
    />
    <paginated-table
      ref="paginatedTable"
      :items="referrals"
      :headers="headers"
      :loading="loading"
      :pullFunction="pullFunction"
      :pagination.sync="pagination"
    >
      <template #items="props">
        <ReferralItem :item="props.item" />
      </template>
    </paginated-table>
    <Base--SideButtons back />
  </div>
</template>

<script>
import lodash from 'lodash'
import {
  getReferrals, deleteReferral, getReferralsDeps
} from '../../api/user'
import ReferralItem from '../components/common/Table/Referrals/ReferralItem'

export default {
  components: { ReferralItem },
  data: () => ({
    searchId: '',
    searchName: '',
    freeAmount: 0,
    moneyReceivedAmount: 0,
    referrals: [],
    pagination: {
      sortBy: 'id',
      descending: false
    },
    refDeps: null,
    loading: true,
    headers: [
      { text: 'User ID', value: 'id' },
      { text: 'Ник', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Аккаунт ВК', value: 'social_network_accounts[0].link' },
      { text: 'Доход', value: 'pivot.income' },
      { text: 'Отвязать рефералов', value: '' }
    ]
  }),
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    searchId () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    searchName () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    }
  },
  mounted () {
    this.$emit('title_changed', `Пользователь ID: ${this.$route.params.user}`)
    getReferralsDeps(this.$route.params.user)
      .then(res => {
        this.refDeps = res.data
      })
      .catch(error => {
        this.refDeps = {
          replenishment_sum: 0,
          replenishment_count: 0,
          output_sum: 0,
          output_count: 0
        }
        console.error(error)
      })
  },
  created () {
    this.$root.$on('remove_item', this.removeItem)
    this.pullFunction(1)
  },
  beforeDestroy () {
    this.$root.$off('remove_item', this.removeItem)
  },
  methods: {
    pullFunction: lodash.debounce(function (page) {
      if (page === 2 && !this.referrals.length > 0) return
      getReferrals(this.$route.params.user, {
        limit: 26,
        offset: (page - 1) * 25,
        id: this.searchId || undefined,
        name: this.searchName || undefined
      }).then(res => {
        this.freeAmount = res.data.referral_programs[0].free_amount
        this.moneyReceivedAmount = res.data.referral_programs[0].money_received_amount
        this.referrals = res.data.referrals
      })
    }, 300),
    removeItem (id) {
      this.AxiosHelperShowResponce(
        deleteReferral(this.$route.params.user, id),
        res => {
          this.referrals.splice(
            this.referrals.findIndex(i => i.id === id),
            1
          )
        }
      )
    }
  }
}
</script>

<style scoped>
.search-input {
  width: 30%;
  margin-left: auto;
  margin-bottom: 10px;
}
</style>
